import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=11f1434f&scoped=true"
import script from "./Expandable.vue?vue&type=script&lang=js"
export * from "./Expandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1434f",
  null
  
)

export default component.exports